import {ValueObject} from '@s-ui/domain'

import {QueryParamSharedValueObject} from '../../shared/ValueObjects/QueryParamSharedValueObject.js'
import {FilterRangeSearchValueObject} from './FilterRangeSearchValueObject.js'

export class FilterDoorsSearchValueObject extends ValueObject {
  #doors

  constructor({doors}) {
    super()
    this.#doors = doors
  }

  static create({doors}) {
    return new FilterDoorsSearchValueObject({doors: FilterRangeSearchValueObject.create(doors)})
  }

  static createWithDefaultValue({config, doors}) {
    const {DEFAULT_DOORS_SEARCH} = config.get('searchFilters')

    return new FilterDoorsSearchValueObject({
      doors: FilterRangeSearchValueObject.create({
        from: doors?.from || DEFAULT_DOORS_SEARCH.from,
        to: doors?.to || DEFAULT_DOORS_SEARCH.to
      })
    })
  }

  static createQueryParams({config, doors}) {
    const {DEFAULT_DOORS_SEARCH, FILTER_NAMES, FILTER_QUERY_PARAMS} = config.get('searchFilters')

    return new FilterDoorsSearchValueObject({
      doors: {
        from: QueryParamSharedValueObject.createForSingle({
          key: FILTER_QUERY_PARAMS[FILTER_NAMES.DOOR].from,
          value: doors?.from || DEFAULT_DOORS_SEARCH.from
        }),
        to: QueryParamSharedValueObject.createForSingle({
          key: FILTER_QUERY_PARAMS[FILTER_NAMES.DOOR].to,
          value: doors?.to || DEFAULT_DOORS_SEARCH.to
        })
      }
    })
  }

  get isEmpty() {
    return this.#doors.isEmpty
  }

  get queryParams() {
    return {
      ...(!this.#doors.from.isEmpty && {...this.#doors.from.queryParam}),
      ...(!this.#doors.to.isEmpty && {...this.#doors.to.queryParam})
    }
  }

  get value() {
    return this.#doors.value
  }

  toJSON() {
    return {
      doors: this.#doors.toJSON()
    }
  }
}
